import React from "react";
import { Link } from "react-router-dom";
import "./FastAdvertSuccess.css";

const COPY = {
  buyer: {
    title: "Alıcı ilanın yayında!",
    sub: "Eşleşen satıcılar sana mesaj atacak. İlk teklifler genelde 1–2 saat içinde gelir.",
  },
  seller: {
    title: "İlanın yayında!",
    sub: "İlanın aranırken çıkacak. Alıcılar sana mesaj atabilir.",
  },
};

function FastAdvertSuccess({ kind = "seller", profileHref = "/hesap" }) {
  const variant = kind === "buyer" ? "buyer" : "seller";
  const { title, sub } = COPY[variant];

  return (
    <div className={`fas fas--${variant}`} role="status" aria-live="polite">
      <div className="fas__stage">
        <span className="fas__halo fas__halo--3" aria-hidden="true" />
        <span className="fas__halo fas__halo--2" aria-hidden="true" />
        <span className="fas__halo fas__halo--1" aria-hidden="true" />
        <div className="fas__badge">
          <svg
            className="fas__check"
            viewBox="0 0 52 52"
            aria-hidden="true"
            focusable="false"
          >
            <path
              d="M14 27 l8 8 l16 -18"
              fill="none"
              stroke="currentColor"
              strokeWidth="5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
      </div>

      <h2 className="fas__title">{title}</h2>
      <p className="fas__sub">{sub}</p>

      <Link to={profileHref} className="fas__cta">
        <span className="fas__cta-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" width="20" height="20">
            <path
              d="M12 5c-5 0-9 4.5-10 7 1 2.5 5 7 10 7s9-4.5 10-7c-1-2.5-5-7-10-7Zm0 11.5a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9Zm0-2.2a2.3 2.3 0 1 0 0-4.6 2.3 2.3 0 0 0 0 4.6Z"
              fill="currentColor"
            />
          </svg>
        </span>
        <span className="fas__cta-text">
          <span className="fas__cta-title">Profili tamamla</span>
          <span className="fas__cta-sub">İlanların 3 kat daha çok görünür</span>
        </span>
        <span className="fas__cta-chevron" aria-hidden="true">
          <svg viewBox="0 0 24 24" width="18" height="18">
            <path
              d="M9 6l6 6-6 6"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </span>
      </Link>
    </div>
  );
}

export default FastAdvertSuccess;
